export default __webpack_public_path__ + "static/media/pro_aim_social_media.1de3419e.png";